import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import { ListButton } from 'components';


/**
 * @desc Release options dropdown menu component
 * @memberof components/ReleaseOptions
 *
 * @param  {Boolean} isDownloadAllowed              [Show 'Download' option]
 * @param  {String} releaseLink              		['Release Information' link target]
 *
 * @param  {Function} t                      		[i18 string getter (Autowired)]
 * @param  {Function} onDownloadClick               [(Optional) 'Download' option click handler]
 * @param  {Function} onAddToPlaylistClick          ['Add to playlist' option click handler]
 *
 * @type {Component}
 */
const ReleaseOptionsMenu = ({ t, isDownloadAllowed, releaseLink, onDownloadClick, onAddToPlaylistClick }) => (
	<React.Fragment>
		{
			isDownloadAllowed &&
				<ListButton
					key={1}
					name={t('general.download')}
					onClick={onDownloadClick} />
		}
		<ListButton
			key={2}
			name={
				<Link
					className="w-full block"
					to={releaseLink}>
					{t('general.release-information')}
				</Link>
			} />
		<ListButton
			key={3}
			name={'+ ' + t('general.addto')}
			onClick={onAddToPlaylistClick} />
	</React.Fragment>
);

ReleaseOptionsMenu.propTypes = {
	isDownloadAllowed: PropTypes.bool,
	releaseLink: PropTypes.string.isRequired,

	t: PropTypes.func.isRequired,
	onDownloadClick: PropTypes.func,
	onAddToPlaylistClick: PropTypes.func.isRequired,
};
ReleaseOptionsMenu.defaultProps = {
	isDownloadAllowed: false
};

export default withTranslation()(ReleaseOptionsMenu);
